import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  src: string
}

const PDF = ({ src }: Props) => {
  return (
    <Box height="full" width="full">
      <iframe src={src} style={{ width: '100%', height: '100%' }} title="PDF viewer" />
    </Box>
  )
}

export default observer(PDF)
